export const FECHACALENDARIO = "SELECT_FECHA_CAL_DD"